import { Card, Table, Button } from 'react-bootstrap';
import { formatDate, formatCurrencyWhole } from '../../utils/formatters';
import { useState } from 'react';

const FplSmiCard = ({ smi, fpl, fplSmiHouseholdAdder, onEdit, onEditAdder}) => {

  return (
    <>
      <Card className="mb-4">
        <Card.Header>
          <h5 className="mb-0">Federal Poverty Level (FPL) & State Median Income (SMI) by Household Size</h5>
        </Card.Header>
        <Card.Body>
          <h6>Adder for Household Size 1-{smi?.length || 0}</h6>
          <div className="table-responsive">
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th className="text-center">Household Size</th>
                  <th className="text-center">FPL Adder</th>
                  <th className="text-center">SMI Adder</th>
                  <th className="text-center">Effective Date</th>
                  <th className="text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                {smi?.map((moi, index) => (
                  <tr key={index}>
                    <td className="text-center align-content-center">
                      {moi.upcomingFplSmi ? (
                        <div className="text-success" title={`Adder change becomes effective: ${formatDate(moi.upcomingFplSmi.effectiveDate)}`}>
                          <strong>{moi.upcomingFplSmi.householdSize}</strong>
                        </div>
                      ) : (
                        <div>{moi.householdSize}</div>
                      )}
                    </td>
                    <td className="text-center align-content-center">
                      <div>{moi.fpl ? formatCurrencyWhole(moi.fpl) : <span className="text-muted">-</span>}</div>
                      {moi.upcomingFplSmi && moi.fpl !== moi.upcomingFplSmi.fpl && (
                        <div className="text-success"><strong>{formatCurrencyWhole(moi.upcomingFplSmi.fpl)}</strong></div>
                      )}
                    </td>
                    <td className="text-center align-content-center">
                      <div>{moi.smi ? formatCurrencyWhole(moi.smi) : <span className="text-muted">-</span>}</div>
                      {moi.upcomingFplSmi && moi.smi !== moi.upcomingFplSmi.smi && (
                        <div className="text-success"><strong>{formatCurrencyWhole(moi.upcomingFplSmi.smi)}</strong></div>
                      )}
                    </td>
                    <td className="text-center align-content-center">
                      <div>{formatDate(moi.effectiveDate)}</div>
                      {moi.upcomingFplSmi && (
                        <div className="text-success"><strong>{formatDate(moi.upcomingFplSmi.effectiveDate)}</strong></div>
                      )}
                    </td>
                  <td className="text-center align-content-center">
                    <Button
                      size="sm"
                      variant="outline-primary"
                      title="Edit FPL / SMI"
                      onClick={() => onEdit(moi)}
                    >Edit</Button>
                  </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>

          <h6 className="mt-4">Adder for Additional Household Size</h6>
          <div className="table-responsive">
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th className="text-center">FPL Household Size</th>
                  <th className="text-center">FPL Adder</th>
                  <th className="text-center">SMI Household Size</th>
                  <th className="text-center">SMI Adder</th>
                  <th className="text-center">Effective Date</th>
                  <th className="text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="text-center align-content-center">
                    {fplSmiHouseholdAdder?.upcomingAdder ? (
                      <div className="text-success" title={`Adder change becomes effective: ${formatDate(fplSmiHouseholdAdder.upcomingAdder.effectiveDate)}`}>
                        <strong>{(fpl?.length || 0) + 1}+</strong>
                      </div>
                    ) : (
                      <div>{(fpl?.length || 0) + 1}+</div>
                    )}
                  </td>
                  <td className="text-center align-content-center">
                    <div>{fplSmiHouseholdAdder?.fplAdderPerHousehold ? formatCurrencyWhole(fplSmiHouseholdAdder.fplAdderPerHousehold) : <span className="text-muted">-</span>}</div>
                    {fplSmiHouseholdAdder?.upcomingAdder && fplSmiHouseholdAdder.fplAdderPerHousehold !== fplSmiHouseholdAdder.upcomingAdder.fplAdderPerHousehold && (
                      <div className="text-success"><strong>{formatCurrencyWhole(fplSmiHouseholdAdder.upcomingAdder.fplAdderPerHousehold)}</strong></div>
                    )}
                  </td>
                  <td className="text-center align-content-center">
                    <div>{(smi?.length || 0) + 1}+</div>
                  </td>
                  <td className="text-center align-content-center">
                    <div>{fplSmiHouseholdAdder?.smiAdderPerHousehold ? formatCurrencyWhole(fplSmiHouseholdAdder.smiAdderPerHousehold) : <span className="text-muted">-</span>}</div>
                    {fplSmiHouseholdAdder?.upcomingAdder && fplSmiHouseholdAdder.smiAdderPerHousehold !== fplSmiHouseholdAdder.upcomingAdder.smiAdderPerHousehold && (
                      <div className="text-success"><strong>{formatCurrencyWhole(fplSmiHouseholdAdder.upcomingAdder.smiAdderPerHousehold)}</strong></div>
                    )}
                  </td>
                  <td className="text-center align-content-center">
                    <div>{formatDate(fplSmiHouseholdAdder?.effectiveDate)}</div>
                    {fplSmiHouseholdAdder?.upcomingAdder && (
                      <div className="text-success"><strong>{formatDate(fplSmiHouseholdAdder.upcomingAdder.effectiveDate)}</strong></div>
                    )}
                  </td>
                  <td className="text-center align-content-center">
                    <Button
                      size="sm"
                      variant="outline-primary"
                      title="Edit Household Adder"
                      onClick={() => onEditAdder(fplSmiHouseholdAdder)}
                    >Edit</Button>
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
        </Card.Body>
      </Card>
    </>
  );
};

export default FplSmiCard;
